<div class="wrapper">
    <div class="m-box">
        <h2>Exams Details </h2>
        <table>
            <tr>
            <th> exam name</th>
            <th>exam Type</th>
            <th>duration (min)</th>
            <th>price</th>
            <th>doctors</th>
            <th>color</th>

            </tr>
            <tr [ngClass]="exam.isEditing? 'tr-isActive' : ''" *ngFor="let exam of exams">
              <td><input class="t-field  menstural-field" [(ngModel)]="exam.examName" [disabled]="!exam.isEditing"></td>
              <td><select class="t-select w100"  [(ngModel)]="exam.examType" [disabled]="!exam.isEditing">
                <option *ngFor="let type of getExamTypes()" [value]="type">{{type}}</option>
              </select></td>
              <td><input class="t-field  menstural-field" [(ngModel)]="exam.Length"  [disabled]="!exam.isEditing"></td>
              <td><input class="t-field  menstural-field" [(ngModel)]="exam.Price" [disabled]="!exam.isEditing"></td>
              <td><mat-form-field >
                <mat-label [ngClass]="['mat-select-value']"> רופאים מבצעים</mat-label>
                <mat-select [(ngModel)]="exam.users" multiple [ngClass]="['mat-select-value','mat-form-field']" >
                  <ng-container *ngFor="let e of this.ls.clinicUsers">
                  <mat-option  [disabled]="!exam.isEditing"  [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td><input class="color-picker" [(ngModel)]="exam.Color" type="color" [disabled]="!exam.isEditing"></td>
              <td>
                <button class="blue-btn" *ngIf="!exam.isEditing" (click)="editExam(exam)">Edit</button>
                <button class="orange-btn" *ngIf="exam.isEditing" (click)="saveChanges(exam)">Save</button>
              </td>
            </tr>
            <tr>
                <td><input class="t-field  menstural-field" [(ngModel)]="newExam.examName"></td>
                <td><select class="t-select w100" [(ngModel)]="newExam.examType" >
                    <option *ngFor="let type of getExamTypes()" [value]="type">{{type}}</option>
                  </select></td>
                <td><input class="t-field  menstural-field" [(ngModel)]="newExam.Length"></td>
              <td><input class="t-field  menstural-field" [(ngModel)]="newExam.Price"></td>
              <td><mat-form-field>
                <mat-label [ngClass]="['mat-select-value']"> בחר רופאים מבצעים</mat-label>
                <mat-select [(ngModel)]="newExam.users" multiple [ngClass]="['mat-select-value','mat-form-field']">
                  <ng-container *ngFor="let e of this.ls.clinicUsers">
                  <mat-option   [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td><input class="color-picker" [(ngModel)]="newExam.Color" type="color"></td>
              <td><button  class="orange-btn" (click)="saveNewExam()">Save New</button></td>
            </tr>
          </table>
    </div>
</div>
